import { experienceQueryKeys as e } from "./useExperienceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { experiencesApi as n } from "@maat/api-main";
//#region src/experiences/useExperienceQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getExperience(r),
	enabled: !!r
});
//#endregion
export { r as useExperienceQuery };
